import ButtonDesigned from '../Buttons/ButtonDesigned';
import React from 'react';

export interface IFlowSummaryItem {
  title: string;
  placeHolder: string;
  value?: string[] | string;
  onClick?: () => void;
}

interface Props {
  title: string;
  dataToPresent: IFlowSummaryItem[];
  isEditMode: boolean;
  subTitle?: string;
  onSecondaryClick?: { text: string; function: () => void; isDisabled?: boolean; isLoading?: boolean };
  onPrimaryClick?: { text: string; function: () => void; isDisabled?: boolean; isLoading?: boolean };
  isButtonsShown?: boolean;
}

export const FlowSummary: React.FC<Props> = ({
  dataToPresent,
  title,
  onPrimaryClick,
  onSecondaryClick,
  subTitle,
  isEditMode,
  isButtonsShown = true,
}) => {
  return (
    <div className="flex flex-col  flex-1 flex-grow py-4 px-4 h-full shadow-custom  bg-white">
      <p className="text-xl">{title}</p>
      {subTitle && <p className="pt-2 text-secondary_text text-sm">{subTitle}</p>}
      <div className="flex flex-col flex-1 justify-between space-y-3 overflow-y-hidden">
        <div className="h-full pt-4 space-y-3 flex-col overflow-auto">
          {dataToPresent.map((item, index) => (
            <div
              key={item.title + index}
              className={`flex flex-col space-y-1.5 py-2 ${isEditMode ? 'border px-2 rounded' : ''}`}
            >
              <p className="text-sm text-gray-700">{item.title}</p>
              <HandleValueText placeHolder={item.placeHolder} value={item.value} />
            </div>
          ))}
        </div>
        {isButtonsShown && (
          <div className="flex flex-1 space-x-4">
            {onSecondaryClick && (
              <ButtonDesigned
                className="py-2 px-4"
                disableButton={onSecondaryClick.isDisabled}
                isFunctionLoading={onSecondaryClick.isLoading}
                style="outline"
                onButtonClick={onSecondaryClick.function}
              >
                {onSecondaryClick.text}
              </ButtonDesigned>
            )}
            {onPrimaryClick && (
              <ButtonDesigned
                className="py-2 px-4"
                disableButton={onPrimaryClick.isDisabled}
                isFunctionLoading={onPrimaryClick.isLoading}
                style="primary"
                onButtonClick={onPrimaryClick.function}
              >
                {onPrimaryClick.text}
              </ButtonDesigned>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

interface IValueTextProps {
  placeHolder: string;
  value?: string | string[];
}

const HandleValueText: React.FC<IValueTextProps> = ({ placeHolder, value }) => {
  if (!value) return <p className="text-base text-gray-400">{placeHolder}</p>;

  if (Array.isArray(value)) {
    return (
      <>
        {value.map((item, index) => (
          <p key={index} className="text-base text-black">
            {item}
          </p>
        ))}
      </>
    );
  }

  return <p className="text-base text-black">{value}</p>;
};
